// assets/component-link-bar.js
(() => {
  // =========================
  // Helpers
  // =========================
  const LINK_SELECTOR = '.link-bar__link';
  const MAIN_CLASS    = '.shopify-section--main-collection';

  const q  = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const parseHTML = (html) => {
    const tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    return tpl.content;
  };

  const dispatch = (name, detail) => {
    document.documentElement.dispatchEvent(new CustomEvent(name, { detail }));
  };

  const isCollectionURL = (urlString) => {
    try {
      const u = new URL(urlString, window.location.origin);
      return u.origin === window.location.origin && /^\/collections\/.+/i.test(u.pathname);
    } catch { return false; }
  };

  // =========================
  // Config UI
  // =========================
  const MIN_ITEMS_FEW      = 3; // < 3 éléments => pas de hint, pas de barre, position static (via CSS)
  const MIN_ITEMS_FOR_GRID = 4;

  // =========================
  // 🔗 Persistance du filtre "magasin favori" dans l'URL
  // (évite un second chargement après navigation AJAX)
  // =========================
  const FAV_LS_KEY         = 'favorite_store_filter_on';
  const FORCE_OFF_SS_KEY   = 'favorite_store_filter_force_off_once';
  const normalize = (s)=>String(s||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/&/g,' and ')
    .replace(/[^a-z0-9]+/g,' ')
    .replace(/\s+/g,' ')
    .trim();
  const isStoreLabelLike = (s)=>{
    const n = normalize(s);
    return n.includes('decathlon saint denis') || n.includes('decathlon saint pierre') || n.includes('decathlon sainte suzanne');
  };
  const stripCountAndMarks = (s)=>String(s||'')
    .replace(/\(\s*\d+\s*\)\s*[\u200e\u200f]?\s*$/u,'')
    .replace(/(&lrm;|&rlm;|\u200e|\u200f)/g,'')
    .trim();

  // récupère {name,value,group} de la facette "magasin favori" visible sur la page
  async function getFavFacetParamOnPage() {
    try {
      const aside = document.querySelector('.product-facet__aside, .facets-vertical') || document;
      if (!aside) return null;

      // 1) via toggle explicite
      let group = null;
      const toggles = aside.querySelectorAll('.collapsible-toggle');
      for (const btn of toggles) {
        if (normalize(btn.textContent).includes('filtrer par magasin')) {
          const id = btn.getAttribute('aria-controls');
          if (id) { group = document.getElementById(id); break; }
        }
      }
      // 2) heuristique
      if (!group) {
        const items = aside.querySelectorAll('.product-facet__filter-item .collapsible, .facets-vertical .facets__list');
        for (const it of items) {
          const labels = Array.from(it.querySelectorAll('label')).map(l => normalize(stripCountAndMarks(l.textContent)));
          const hits = ['decathlon saint denis','decathlon saint pierre','decathlon sainte suzanne'].filter(k => labels.some(t => t.includes(k)));
          if (hits.length >= 2) { group = it; break; }
        }
      }
      if (!group) return null;

      const favName = localStorage.getItem('favorite_store_name') || '';
      const favLabelNorm = normalize(favName);
      if (!favLabelNorm) return null;

      const inputs = group.querySelectorAll('input[type="checkbox"][name]');
      for (const input of inputs) {
        const esc = (window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id;
        let lab = group.querySelector(`label[for="${esc}"]`);
        if (!lab && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') lab = input.nextElementSibling;
        if (!lab) lab = input.closest('label');
        const cleaned = stripCountAndMarks(lab ? lab.textContent : '');
        const n = normalize(cleaned);
        if (isStoreLabelLike(n) && (n === favLabelNorm || n.startsWith(favLabelNorm))) {
          return { name: input.name, value: input.value, group };
        }
      }
    } catch (_e) {}
    return null;
  }

  async function withFavoriteFacet(url) {
    // switch OFF → ne rien faire
    if (localStorage.getItem(FAV_LS_KEY) !== '1') return url;
    if (sessionStorage.getItem(FORCE_OFF_SS_KEY) === '1') return url;

    const fav = await getFavFacetParamOnPage();
    if (!fav) return url;

    const u = new URL(url, window.location.origin);

    // retire toutes les valeurs "magasin" existantes (même groupe) pour éviter doublons
    if (fav.group) {
      const inputs = fav.group.querySelectorAll('input[type="checkbox"][name]');
      inputs.forEach(i => {
        const esc = (window.CSS && CSS.escape) ? CSS.escape(i.id) : i.id;
        let lab = fav.group.querySelector(`label[for="${esc}"]`);
        if (!lab && i.nextElementSibling && i.nextElementSibling.tagName === 'LABEL') lab = i.nextElementSibling;
        if (!lab) lab = i.closest('label');
        const cleaned = stripCountAndMarks(lab ? lab.textContent : '');
        if (isStoreLabelLike(cleaned)) u.searchParams.delete(i.name, i.value);
      });
    }

    // ajoute le favori
    u.searchParams.append(fav.name, fav.value);
    return u.toString();
  }

  // =========================
  // Détection des sections à rafraîchir
  // =========================
  const getSectionsToRefresh = (fromEl) => {
    const ids = new Set();

    const inBanner = fromEl?.closest?.('.shopify-section');
    const bannerWrapper = inBanner || q('.link-bar')?.closest('.shopify-section');
    if (bannerWrapper && bannerWrapper.id.startsWith('shopify-section-')) {
      ids.add(bannerWrapper.id.replace('shopify-section-', ''));
    }

    const mainWrapper = q(MAIN_CLASS);
    if (mainWrapper && mainWrapper.id.startsWith('shopify-section-')) {
      ids.add(mainWrapper.id.replace('shopify-section-', ''));
    }

    return Array.from(ids);
  };

  // =========================
  // Remplacement de sections
  // =========================
  const replaceSectionHTML = (sectionId, htmlMap) => {
    const html = htmlMap[sectionId];
    if (!html) return;
    const target = document.getElementById(`shopify-section-${sectionId}`);
    if (!target) return;
    const fresh = parseHTML(html).firstElementChild;
    target.replaceWith(fresh);
  };

  // =========================
  // Navigation AJAX + Loader natif
  // =========================
  const ajaxNavigate = async (url, fromEl) => {
    const sectionsToRefresh = getSectionsToRefresh(fromEl);
    if (!sectionsToRefresh.length) { window.location.href = url; return; }

    // ⬇️ injecte le filtre favori dans l'URL si ON
    url = await withFavoriteFacet(url);

    const ajaxURL = new URL(url, window.location.origin);
    ajaxURL.searchParams.set('sections', sectionsToRefresh.join(','));

    dispatch('theme:loading:start');
    try {
      const res = await fetch(ajaxURL.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();

      sectionsToRefresh.forEach((id) => replaceSectionHTML(id, json));
      window.history.pushState({ ajax: true }, '', url); // push l'URL ENRICHIE
      document.dispatchEvent(new CustomEvent('sections:reloaded'));
    } catch (err) {
      console.error('AJAX navigation failed → hard navigation', err);
      window.location.href = url;
    } finally {
      dispatch('theme:loading:end');
    }
  };

  // =========================
  // Délégation clics
  // =========================
  document.addEventListener('click', (evt) => {
    // a) lien link-bar
    let a = evt.target.closest(LINK_SELECTOR);
    if (a) {
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || a.target === '_blank') return;
      const href = a.getAttribute('href');
      if (!href) return;
      evt.preventDefault();
      ajaxNavigate(href, a);
      return;
    }
    // b) breadcrumb → collections
    a = evt.target.closest('nav.breadcrumb a.breadcrumb__link[href]');
    if (a && isCollectionURL(a.href)) {
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || a.target === '_blank') return;
      evt.preventDefault();
      ajaxNavigate(a.href, a);
    }
  });

  // =========================
  // Back/forward (popstate)
  // =========================
  window.addEventListener('popstate', () => {
    ajaxNavigate(window.location.href, q('.link-bar') || document.body);
  });

  // =========================
  // Logique UI link-bar (unchanged, petites optimisations)
  // =========================
  let cleanup = null;

  const bindLinkBarUI = () => {
    if (typeof cleanup === 'function') cleanup();

    const linkBar    = q('.link-bar');
    if (!linkBar) { cleanup = null; return; }

    const wrapper    = q('.link-bar__wrapper', linkBar);
    const scroller   = q('.link-bar__scroller', linkBar);
    const scrollHint = q('.scroll-hint', linkBar);
    const toggleBtn  = q('.link-bar__toggle-grid', linkBar);
    const linkList   = q('.link-bar__linklist', linkBar);

    if (!wrapper || !scroller || !scrollHint || !toggleBtn || !linkList) { cleanup = null; return; }

    let itemWidth = 0;
    let resizeTimer;
    let mo;

    const getItemsCount = () => {
      const fromData = Number(linkBar.dataset.itemsCount || 0);
      if (fromData > 0) return fromData;
      return linkList.querySelectorAll('.link-bar__link-item').length;
    };

    const syncFewItemsClass = () => {
      const count = getItemsCount();
      const isFew = count < MIN_ITEMS_FEW;
      linkBar.classList.toggle('link-bar--few', isFew);
      return { count, isFew };
    };

    const updateItemWidth = () => {
      const first = q('.link-bar__link-item', linkList);
      if (first) itemWidth = first.offsetWidth || 0;
    };

    const shouldShowToggleButton = () => getItemsCount() >= MIN_ITEMS_FOR_GRID;

    const updateToggleVisibility = () => {
      if (window.innerWidth < 1000) {
        toggleBtn.classList.remove('show');
        linkBar.classList.remove('link-bar--grid');
        return;
      }
      const show = shouldShowToggleButton();
      toggleBtn.classList.toggle('show', show);
      if (!show) linkBar.classList.remove('link-bar--grid');
    };

    const onToggleClick = () => {
      if (!shouldShowToggleButton()) { updateToggleVisibility(); return; }
      const startH = linkList.offsetHeight;
      const isGrid = linkBar.classList.toggle('link-bar--grid');
      toggleBtn.setAttribute('aria-expanded', isGrid);
      const endH = linkList.offsetHeight;

      linkList.style.height     = `${startH}px`;
      linkList.style.transition = 'height 0.3s ease';
      requestAnimationFrame(() => { linkList.style.height = `${endH}px`; });
      const onEnd = () => {
        linkList.style.height = '';
        linkList.style.transition = '';
        linkList.removeEventListener('transitionend', onEnd);
      };
      linkList.addEventListener('transitionend', onEnd, { once: true });
    };

    const refreshScrollHintState = () => {
      const canScroll = (scroller.scrollWidth - scroller.clientWidth) > 1;
      scroller.dataset.canScroll = canScroll ? 'true' : 'false';
      scroller.dataset.atStart   = canScroll && scroller.scrollLeft < 20 ? 'true' : 'false';
    };

    const onScrollerScroll = () => {
      const canScroll = scroller.dataset.canScroll === 'true';
      scroller.dataset.atStart = canScroll && scroller.scrollLeft < 20 ? 'true' : 'false';
    };

    const onWindowResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateItemWidth();
        updateToggleVisibility();
        syncFewItemsClass();
        refreshScrollHintState();
      }, 100);
    };

    mo = new MutationObserver(() => {
      updateItemWidth();
      updateToggleVisibility();
      syncFewItemsClass();
      refreshScrollHintState();
    });
    mo.observe(linkList, { childList: true, subtree: true });

    scroller.addEventListener('scroll', onScrollerScroll, { passive: true });
    toggleBtn.addEventListener('click', onToggleClick);
    window.addEventListener('resize', onWindowResize);

    updateItemWidth();
    updateToggleVisibility();
    syncFewItemsClass();
    refreshScrollHintState();

    cleanup = () => {
      scroller.removeEventListener('scroll', onScrollerScroll);
      toggleBtn.removeEventListener('click', onToggleClick);
      window.removeEventListener('resize', onWindowResize);
      if (mo) mo.disconnect();
      cleanup = null;
    };
  };

  document.addEventListener('DOMContentLoaded', bindLinkBarUI);
  document.addEventListener('sections:reloaded', bindLinkBarUI);
})();
